import '../../style/footer/footer.scss';
import '../util/global-shim';
import { main } from './main/main';
import initExperimentation from './util/footerMenu';
/**
 * This is the main js entry point.
 *
 * @param win Window object. Pass in to allow for window stubbing.
 * @returns {Window}
 */

main(window);
window.addEventListener('load', async () => {
  // eslint-disable-next-line no-console
  console.log('[footerABTest] is Adobe available?: ', window?.adobe?.target);

  await initExperimentation();
});